import Vue from 'vue'
import Vuex from 'vuex'
import game from './modules/game'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    userInfo: null
  },
  mutations: {
    setUserInfo(state, userInfo) {
      state.userInfo = userInfo
    }
  },
  actions: {
    updateUserInfo({ commit }, userInfo) {
      commit('setUserInfo', userInfo)
    }
  },
  getters: {
    getUserInfo: state => state.userInfo
  },
  modules: {
    game
  }
}) 